/**
 * Computes the 1-based serial number ("#") for a row in a table.
 *
 * @param rowIndex Zero-based position of the row within the current page.
 * @param page     1-based current page number.
 * @param pageSize Number of rows shown per page.
 */
export function rowSerial(rowIndex: number, page = 1, pageSize = 0): number {
  return (Math.max(1, page) - 1) * Math.max(0, pageSize) + rowIndex + 1;
}
